import status from "state/reducers/status";
import products from "state/reducers/products";
import applicationUI from "state/reducers/ui/applicationUI";
import miniCartUI from "state/reducers/ui/miniCartUI";

export default {
  status,
  applicationUI,
  products,
  miniCartUI
};
